import clsx from "clsx";

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "common/components/ui/Accordion";
import { Tag } from "common/components/ui/Tag";
import { LEADS_FACETS } from "common/constants";

import type { JSX } from "react";
import type { AudienceFacets, AudienceFilters } from "../../../../types";

interface AudienceFilterMobileProps {
  facetKey: keyof AudienceFacets;
  isMiningTargets: boolean;
  filters: AudienceFilters;
  contentComponent: JSX.Element;
}

export default function AudienceFilterMobile({
  facetKey,
  isMiningTargets,
  filters,
  contentComponent,
}: AudienceFilterMobileProps) {
  const selection = filters[facetKey];
  const { icon: Icon, label } = LEADS_FACETS[facetKey];

  return (
    <AccordionItem value={facetKey}>
      <AccordionTrigger
        className={clsx([
          "h-14",
          isMiningTargets && "pointer-events-none opacity-50",
        ])}
      >
        <Icon size={20} weight="fill" />

        <span>{label}</span>

        {Array.isArray(selection) && !!selection.length && (
          <Tag variant="primary-black">{selection.length}</Tag>
        )}
      </AccordionTrigger>

      <AccordionContent>{contentComponent}</AccordionContent>
    </AccordionItem>
  );
}
